{
  "acorn-squash": "橡果南瓜",
  "adjuma-pepper": "阿茹玛辣椒",
  "aji-dulce-pepper": "阿吉杜尔塞辣椒",
  "aleppo-pepper": "阿勒颇辣椒",
  "almond": "杏仁",
  "anaheim-pepper": "阿纳海姆辣椒",
  "apple": "苹果",
  "apricot": "杏子",
  "artichoke": "朝鲜蓟",
  "arugula": "芝麻菜",
  "asian-pear": "亚洲梨",
  "asparagus": "芦笋",
  "banana-pepper": "香蕉辣椒",
  "barley": "大麦",
  "basil": "罗勒",
  "beet": "甜菜",
  "belgian-endive": "比利时菊苣",
  "bibb-lettuce": "比布生菜",
  "bing-cherry": "宾樱桃",
  "birds-eye-chili": "鸟眼辣椒",
  "bishops-crown-pepper": "主教冠辣椒",
  "black-habanero": "黑色哈瓦那辣椒",
  "black-prince-tomato": "黑王子番茄",
  "black-salsify": "黑婆罗门参",
  "blackberry": "黑莓",
  "blue-lake-bean": "蓝湖豆",
  "blue-oyster-mushroom": "蓝平菇",
  "blueberry": "蓝莓",
  "bok-choy": "小白菜",
  "borage": "琉璃苣",
  "brazilian-starfish-pepper": "巴西海星辣椒",
  "broccoli": "西兰花",
  "brussels-sprout": "球芽甘蓝",
  "butternut-squash": "奶油南瓜",
  "california-poppy": "加州罂粟",
  "cannabis": "大麻",
  "cantaloupe": "哈密瓜",
  "carrot": "胡萝卜",
  "cascabel-chili": "响板辣椒",
  "cauliflower": "花椰菜",
  "cayenne-pepper": "卡宴辣椒",
  "celeriac-root": "根芹",
  "celery": "芹菜",
  "chamomile": "洋甘菊",
  "chantrelle-mushroom": "鸡油菌",
  "cheongyang-pepper": "清阳辣椒",
  "cherokee-purple-tomato": "切罗基紫番茄",
  "cherry-belle-radish": "樱桃红萝卜",
  "cherry-stuffer-pepper": "樱桃塞馅辣椒",
  "cherry-tomato": "樱桃番茄",
  "chile-de-aborol-pepper": "阿博罗辣椒",
  "cilantro": "香菜",
  "cinnamon-cap-mushroom": "肉桂平菇",
  "claytonia": "克莱通尼草",
  "collard-greens": "羽衣甘蓝",
  "corn": "玉米",
  "cotton": "棉花",
  "cremini-mushroom": "克里米尼蘑菇",
  "cubanelle-pepper": "古巴内拉辣椒",
  "cucumber": "黄瓜",
  "curly-endive": "卷叶苦苣",
  "curly-kale": "卷叶羽衣甘蓝",
  "dandelion": "蒲公英",
  "dark-opal-basil": "深紫罗勒",
  "datil-pepper": "达提尔辣椒",
  "delicata-squash": "精致南瓜",
  "diablito-pepper": "迪亚布利托辣椒",
  "dill": "莳萝",
  "dundicut-pepper": "顿迪库特辣椒",
  "echinacea": "紫锥菊",
  "eggplant": "茄子",
  "facing-heaven-pepper": "朝天椒",
  "fatilii-pepper": "法蒂利辣椒",
  "fava-bean": "蚕豆",
  "fennel": "茴香",
  "flower": "花卉",
  "french-breakfast-radish": "法式早餐萝卜",
  "fresno-pepper": "弗雷斯诺辣椒",
  "fuji-apple": "富士苹果",
  "gala-apple": "嘎啦苹果",
  "galangal": "高良姜",
  "garlic": "大蒜",
  "garlic-chives": "蒜苗",
  "generic-plant": "通用植物",
  "german-chamomile": "德国洋甘菊",
  "ghost-pepper": "鬼椒",
  "ginger": "生姜",
  "golden-beet": "金色甜菜",
  "golden-delicious-apple": "金冠苹果",
  "granny-smith-apple": "青苹果",
  "green-anjou-pear": "绿安茹梨",
  "green-bartlett-pear": "绿巴特利特梨",
  "green-bell-pepper": "青椒",
  "green-birds-eye-chili": "绿鸟眼辣椒",
  "green-cabbage": "绿卷心菜",
  "green-onion": "青葱",
  "green-serrano-pepper": "绿塞拉诺辣椒",
  "green-tabasco-pepper": "绿塔巴斯克辣椒",
  "green-zebra-tomato": "绿斑马番茄",
  "guajillo-pepper": "瓜希略辣椒",
  "habanero-pepper": "哈瓦那辣椒",
  "hemp": "大麻纤维",
  "hillbilly-tomato": "山民番茄",
  "honeydew-melon": "甜瓜",
  "hop": "啤酒花",
  "hungarian-wax-pepper": "匈牙利蜡辣椒",
  "iceberg-lettuce": "冰山生菜",
  "icicle-radish": "冰柱萝卜",
  "indigo": "靛蓝",
  "jalapeno": "哈拉佩诺辣椒",
  "japanese-yam": "日本山药",
  "kabocha-squash": "日式南瓜",
  "kohlrabi": "球茎甘蓝",
  "lacinato-kale": "托斯卡纳羽衣甘蓝",
  "lavender": "薰衣草",
  "leek": "韭葱",
  "lemon-balm": "柠檬香蜂草",
  "lemon-drop-pepper": "柠檬滴辣椒",
  "lemon-verbena": "柠檬马鞭草",
  "lemongrass": "柠檬草",
  "lima-bean": "利马豆",
  "lions-mane-mushroom": "狮子鬃毛蘑菇",
  "looseleaf-lettuce": "散叶生菜",
  "lovage": "独活草",
  "madame-jeanette-pepper": "珍妮特夫人辣椒",
  "malagueta-pepper": "马拉盖塔辣椒",
  "marjoram": "马郁兰",
  "marshmallow": "药蜀葵",
  "medusa-pepper": "美杜莎辣椒",
  "melon": "甜瓜",
  "millet": "小米",
  "mint": "薄荷",
  "money-tree": "发财树",
  "mugwort": "艾草",
  "mushroom": "蘑菇",
  "napa-cabbage": "大白菜",
  "nectarine": "油桃",
  "oat": "燕麦",
  "okra": "秋葵",
  "onion-chive": "细香葱",
  "orange-bell-pepper": "橙甜椒",
  "orange-scotch-bonnet": "橙苏格兰圆帽辣椒",
  "oregano": "牛至",
  "ornamental-gourd": "观赏葫芦",
  "parsley": "欧芹",
  "parsnip": "防风草",
  "pattypan-squash": "扁圆南瓜",
  "peach": "桃子",
  "peanut": "花生",
  "peppadew-pepper": "佩帕德温辣椒",
  "pequin-pepper": "佩金辣椒",
  "peter-pepper": "彼得辣椒",
  "pimento-pepper": "皮门托辣椒",
  "pineapple-tomato": "菠萝番茄",
  "pink-oyster-mushroom": "粉红平菇",
  "plantain": "大蕉",
  "plum": "李子",
  "poblano-pepper": "波布拉诺辣椒",
  "pointed-cabbage": "尖头卷心菜",
  "porcini-mushroom": "牛肝菌",
  "portabello-mushroom": "波塔贝罗蘑菇",
  "psilocybin-mushroom": "裸盖菇",
  "pumpkin": "南瓜",
  "purple-carrot": "紫胡萝卜",
  "purple-cauliflower": "紫花椰菜",
  "purple-pod-bean": "紫荚豆",
  "purple-potato": "紫土豆",
  "radicchio": "红菊苣",
  "rainbow-chard": "彩虹瑞士甜菜",
  "rainier-cherry": "雷尼尔樱桃",
  "raspberry": "覆盆子",
  "red-anjou-pear": "红安茹梨",
  "red-bartlett-pear": "红巴特利特梨",
  "red-bell-pepper": "红椒",
  "red-cabbage": "红卷心菜",
  "red-carrot": "红胡萝卜",
  "red-chard": "红瑞士甜菜",
  "red-curly-kale": "红卷叶羽衣甘蓝",
  "red-giant-mustard": "红巨芥菜",
  "red-gold-potato": "红金土豆",
  "red-kuri-squash": "红栗南瓜",
  "red-onion": "红洋葱",
  "red-pointed-cabbage": "红尖头卷心菜",
  "red-russian-kale": "红俄罗斯羽衣甘蓝",
  "red-savina-pepper": "红萨维纳辣椒",
  "red-scotch-bonnet": "红苏格兰圆帽辣椒",
  "red-serrano-pepper": "红塞拉诺辣椒",
  "red-tabasco-pepper": "红塔巴斯克辣椒",
  "rice": "水稻",
  "rocoto-pepper": "罗科托辣椒",
  "romaine-lettuce": "罗马生菜",
  "rosemary": "迷迭香",
  "runner-bean": "红花菜豆",
  "russet-potato": "褐皮土豆",
  "rutabaga": "芜菁甘蓝",
  "rye": "黑麦",
  "sage": "鼠尾草",
  "salsify": "婆罗门参",
  "santa-fe-grande-pepper": "圣达菲辣椒",
  "savoy-cabbage": "皱叶卷心菜",
  "shallot": "红葱头",
  "shiitake-mushroom": "香菇",
  "shishito-pepper": "狮子头辣椒",
  "siling-labuyo-pepper": "西林拉布约辣椒",
  "snap-pea": "甜豌豆",
  "soybean": "大豆",
  "spaghetti-squash": "意面南瓜",
  "spinach": "菠菜",
  "spring-onion": "春葱",
  "st-johns-wort": "圣约翰草",
  "stevia": "甜菊",
  "strawberry": "草莓",
  "striped-cavern-tomato": "条纹空心番茄",
  "sugarcane": "甘蔗",
  "sunflower": "向日葵",
  "sunray-tomato": "阳光番茄",
  "sweet-italian-pepper": "甜意大利辣椒",
  "sweet-potato": "红薯",
  "swiss-chard": "瑞士甜菜",
  "taro": "芋头",
  "thyme": "百里香",
  "tomatillo": "墨西哥绿番茄",
  "tomato": "番茄",
  "trinidad-moruga-scorpion-pepper": "特立尼达莫鲁加蝎子椒",
  "trinidad-scorpion-butch-t-pepper": "特立尼达蝎子椒",
  "trumpet-mushroom": "喇叭菇",
  "tulsi": "圣罗勒",
  "turmeric": "姜黄",
  "turnip": "大头菜",
  "watercress": "豆瓣菜",
  "watermelon": "西瓜",
  "watermelon-radish": "西瓜萝卜",
  "wax-bean": "黄四季豆",
  "wheat": "小麦",
  "white-button-mushroom": "白蘑菇",
  "white-carrot": "白胡萝卜",
  "white-onion": "白洋葱",
  "white-oyster-mushroom": "白平菇",
  "wormwood": "苦艾",
  "yellow-bell-pepper": "黄甜椒",
  "yellow-carrot": "黄胡萝卜",
  "yellow-cauliflower": "黄花椰菜",
  "yellow-onion": "黄洋葱",
  "yellow-oyster-mushroom": "黄平菇",
  "yellow-scotch-bonnet": "黄苏格兰圆帽辣椒",
  "yellow-squash": "黄西葫芦",
  "yukon-gold-potato": "育空黄金土豆",
  "zucchini": "西葫芦"
}
